<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>CNPJ</th>
          <th>Código ANS</th>
          <th>Particular</th>
          <th>Situação</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="convenio in convenios" :key="convenio._od">
          <td>{{ convenio.nome }}</td>
          <td>{{ formatarCnpj(convenio.cnpj) }}</td>
          <td>{{ convenio.ans }}</td>
          <td>{{ convenio.particular ? 'Sim' : 'Não' }}</td>
          <td>{{ convenio.ativo ? 'Ativo' : 'Cancelado' }}</td>
          <td>
            <RouterLink
              v-tooltip="'Editar'"
              data-test-id="link-auto-1"
              :to="'/convenio/cadastro/' + convenio._id"
              role="button"
              class="btn btn-xs btn-link"
            >
              <span class="fa fa-edit" />
            </RouterLink>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'ConvenioTabela',
  props: {
    convenios: {
      type: Array,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
